import { SOFTWARE } from '../constant/actionTypes';

const getSoftwarePlatforms = (state, action) => {
  switch (action.type) {
    case SOFTWARE.PLATFORMS.INITIATE:
      return { isFetching: true };
    case SOFTWARE.PLATFORMS.SUCCESS:
      return { isFetching: false, data: action.payload };
    case SOFTWARE.PLATFORMS.ERROR:
      return { isFetching: false, data: action.payload };
    default:
      return (typeof state === 'undefined') ? [] : state;
  }
};

export default getSoftwarePlatforms;
